import { render } from "./Error404.vue?vue&type=template&id=4efb8951&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=4efb8951&scoped=true&lang=scss"

import exportComponent from "/private/var/folders/bn/cmp7482d0pnd0bj6pmy1gdj40000gn/T/deploy/apps-ui/cc5c57464fa762e80846f6594c566a96d2b419a8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efb8951"]])

export default __exports__